import { render, staticRenderFns } from "./fireExtinguisher.vue?vue&type=template&id=9ad84ffa"
import script from "./fireExtinguisher.vue?vue&type=script&lang=js"
export * from "./fireExtinguisher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports